import React, { lazy, Suspense, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Branding from "./pages/Branding";
import FilmMaking from "./pages/FilmMaking";
import VideoEditing from "./pages/VideoEditing";
import MotionGraphics from "./pages/MotionGraphics";
import WebDevelopment from "./pages/WebDevelopment";
import UIUXDesign from "./pages/UIUXDesign";
import SocialMedia from "./pages/SocialMedia";
// import SEOPerformance from "./pages/SEOPerformance";
import PerformanceMarketing from "./pages/PerformanceMarketing";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Careers from "./pages/Careers";
import Portfolio from "./pages/Portfolio";
import Stack from "./pages/Stack";
import Team from "./pages/Team";
import ServicesPage from "./pages/Services";
import Admin from "./pages/Admin";
import NotFound from "./pages/NotFound";
import Growth from "./pages/Growth";
import { Toaster } from "./components/ui/sonner";

import { HelmetProvider } from "react-helmet-async";
import SchemaMarkup from "./components/SchemaMarkup";

const ChitraPortfolioPage = lazy(() => import("./chitra-portfolio/ChitraPortfolioPage"));
const PawanPortfolioPage = lazy(() => import("./pawan-portfolio/PawanPortfolioPage"));

function App() {
  useEffect(() => {
    // Only disable in production, not on localhost
    if (window.location.hostname === "localhost") return;

    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    const handleKeyDown = (e) => {
      if (
        e.keyCode === 123 ||
        (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74)) ||
        (e.ctrlKey && e.keyCode === 85)
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <HelmetProvider>
      <div className="App">
        <SchemaMarkup />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/services/branding" element={<Branding />} />
            <Route path="/services/film-making" element={<FilmMaking />} />
            <Route path="/services/video-editing" element={<VideoEditing />} />
            <Route path="/services/motion-graphics" element={<MotionGraphics />} />
            <Route path="/services/web-development" element={<WebDevelopment />} />
            <Route path="/services/ui-ux-design" element={<UIUXDesign />} />
            <Route path="/services/social-media" element={<SocialMedia />} />
            {/* <Route path="/services/seo-performance" element={<SEOPerformance />} /> */}
            <Route path="/services/performance-marketing" element={<PerformanceMarketing />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/stack" element={<Stack />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/team" element={<Team />} />
            <Route path="/chitra" element={
              <Suspense fallback={<div style={{ background: '#000', minHeight: '100vh' }} />}>
                <ChitraPortfolioPage />
              </Suspense>
            } />
            <Route path="/pawan" element={
              <Suspense fallback={<div style={{ background: '#000', minHeight: '100vh' }} />}>
                <PawanPortfolioPage />
              </Suspense>
            } />
            <Route path="/growth" element={<Growth />} />
            <Route path="/meraki-admin" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#14110f",
              border: "1px solid rgba(201,169,97,0.25)",
              color: "#f5f0e6"
            }
          }}
        />
      </div>
    </HelmetProvider>
  );
}

export default App;
